import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  loader: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '50vh',
  },
  errorContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '56px 40px',
    borderRadius: '16px',
    minHeight: '340px',
    gap: '16px',
  },
  errorIconWrap: {
    width: '56px',
    height: '56px',
    borderRadius: '50%',
    background: 'rgba(220, 38, 38, 0.15)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 0 0 8px rgba(220, 38, 38, 0.08), 0 0 24px rgba(220, 38, 38, 0.3)',
    marginBottom: '4px',
    animation: '$errorPulse 2s ease-in-out infinite',
  },
  '@keyframes errorPulse': {
    '0%, 100%': {
      boxShadow: '0 0 0 0 rgba(220, 38, 38, 0.4), 0 0 0 0 rgba(220, 38, 38, 0.2)',
      transform: 'scale(1)',
    },
    '50%': {
      boxShadow: '0 0 0 12px rgba(220, 38, 38, 0), 0 0 0 24px rgba(220, 38, 38, 0)',
      transform: 'scale(1.08)',
    },
  },
  errorText: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '6px',
  },
  errorTitle: {
    color: '#111827',
    fontWeight: 700,
    fontSize: '1.0625rem',
    textAlign: 'center',
  },
  errorMessage: {
    color: '#6b7280',
    fontSize: '0.875rem',
    textAlign: 'center',
    maxWidth: '340px',
    lineHeight: 1.6,
  },
  '@keyframes pulse': {
    '0%, 100%': { boxShadow: '0 0 0 0 rgba(220, 38, 38, 0.15)' },
    '50%': { boxShadow: '0 0 0 8px rgba(220, 38, 38, 0)' },
  },
  header: {
    marginBottom: '1.5rem',
  },
  title: {
    fontWeight: 600,
    color: '#1a1a1a',
    marginBottom: '0.375rem',
    fontSize: '1.25rem',
  },
  subtitle: {
    color: '#6c757d',
    fontSize: '0.875rem',
    lineHeight: 1.5,
  },
  summaryBar: {
    display: 'flex',
    gap: '1rem',
    marginBottom: '1.75rem',
    flexWrap: 'wrap',
  },
  summaryItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.625rem 1rem',
    backgroundColor: '#fff',
    border: '1px solid #e8e8e8',
    borderRadius: '10px',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.04)',
  },
  summaryIcon: {
    width: '32px',
    height: '32px',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  summaryIconPrimary: {
    background: 'linear-gradient(135deg, #eef2ff 0%, #e0e7ff 100%)',
    '& svg': { color: '#4c4cff' },
  },
  summaryIconGreen: {
    background: 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)',
    '& svg': { color: '#16a34a' },
  },
  summaryLabel: {
    fontSize: '0.6875rem',
    color: '#9e9e9e',
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
    fontWeight: 500,
  },
  summaryValue: {
    fontSize: '1.125rem',
    fontWeight: 700,
    color: '#1a1a1a',
    lineHeight: 1,
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
    gap: '1.25rem',
  },
});

export default useStyles;
